<template>
  <el-form inline size="mini" :model="formData" :rules="rules" ref="form">
    <div class="card-title card-title--left" style="">关联询单</div>
    <div class="form-card">
      <el-form-item label="询单编号" prop="iq_id">
        <el-select v-if="editField==='iq_nm'||!formData.iq_nm"
                   v-model="formData.iq_id"
                   placeholder="请选择要关联的询单"
                   :loading="iqIdOptionLoading"
                   :filter-method="loadIqIdOption"
                   @change="iqIdHandleSelect"
                   @focus="selectEditField('iq_nm')"
                   filterable
                   clearable
                   style="max-width: 400px">
          <el-option :key="'0'" :value="defIq.id" :label="defIq.text"/>
          <el-option v-for="item in iqIdOptions"
                     :key="item.id"
                     :label="item.text"
                     :value="item.id"/>
        </el-select>
        <div class="input-val" @click="selectEditField('iq_nm')" v-else>
          <span class="form-data-iq-id">{{ formData.iq_nm || '' }}</span>
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import {getIqIdOption} from "@/api/adOrder";

/**
 * 关联询单模块 Inquiry
 * @description 保存订单页面
 */
export default {
  name: "PartBaseInquiry",
  props: {
    formData: {
      type: Object,
      required: true
    },
    editField: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pt: Number,
  },
  data() {
    return {
      defIq: {id: 0, text: '(0)无[无类型]'},
      searchIqNm: '', // 查询询单项目名称
      iqIdOptions: [], // 询单选项列表
      iqIdOptionLoading: false,
    }
  },
  computed: {
    rules() {
      return this.$parent.rules
    }
  },
  mounted() {
    // 初始化加载询单项目列表
    this.initIqNmSearch(this.formData.iq_nm)
  },
  methods: {
    validateForm() {
      let form = Object.assign({}, this.formData);
      this.$refs.form.validate((bool) => {
        if (!bool) {
          form = bool
        }
      });
      return form
    },
    selectEditField: function () {
      this.$emit('selectEditField', 'iq_nm')
    },
    initIqNmSearch: async function (nm) {
      if (nm) {
        // 分割提取询单项目名称
        nm = (nm.split(')')[1] || '').split('[')[0] || ''
        // 加载询单项目列表
        await this.loadIqIdOption(nm)
      }
    },
    // 处理搜索结果的选中
    iqIdHandleSelect(value) {
      if (value === 0 && value === this.defIq.id) {
        this.formData.iq_id = this.defIq.id
        this.formData.iq_nm = this.defIq.text
      } else {
        const item = this.iqIdOptions.find(item => item.id === value)
        this.formData.iq_id = item.id ? item.id : null
        this.formData.iq_nm = item.text ? item.text : ''
      }
    },
    loadIqIdOption: async function (value) {
      if (value !== this.searchIqNm) {
        this.iqIdOptionLoading = true
        await getIqIdOption({name: value}).then(({model: {list}}) => {
          this.iqIdOptions = list
          this.iqIdOptionLoading = false
          this.searchIqNm = value
        })
      }
    }
  }
}
</script>

<style scoped>
.card-title.card-title--left {
  padding-left: 34px !important;
}

.card-title--left::after {
  left: 22px !important;
}

::v-deep {
  .el-form-item {
    margin-right: 0;
    min-height: 36px;
    width: 90% !important;
  }

  .input-val {
    width: 100%!important;
  }
  .el-form-item__content{
    width: 500px;
    .el-select{
      width: 100%;
    }
  }
}

</style>


